
import { Styled } from './Styled';

interface ModalProps {
    children?: React.ReactNode;
    index?: number;
}

export const Modal = ({ children, index = 0 }: ModalProps) => {
    

    return (
        <Styled.Content  index={index} $hasOverlay={index === 0}>
            {children}
        </Styled.Content>
    );
};
